<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'home' })"
          v-tooltip="$t('back')"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('homework.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homework.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <div>
        <ts-card>
          <div class="overflow-auto">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
              :rowGroup="{
                field: 'teacher_name'
              }"
            >
              <template v-slot="{ record }">
                <td class="ts-whitespace-no-wrap">
                  {{ record.homework_date }}
                </td>
                <td class="ts-whitespace-no-wrap">{{ record.class_name }}</td>
                <td class="ts-whitespace-no-wrap">{{ record.subject_name }}</td>
                <td class="ts-whitespace-no-wrap">{{ record.remarks }}</td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.submission_end_date }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{
                    record.student_homework.length > 0
                      ? record.student_homework[0].score
                      : ''
                  }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  <a
                    href="#"
                    class="text-primary"
                    v-tooltip="$t('view')"
                    @click.prevent="onView(record)"
                  >
                    <i class="fas fa-eye"></i>
                  </a>
                  <a
                    href="#"
                    class="ml-2 text-info"
                    v-tooltip="$t('homework.comment')"
                    v-if="record.homework_status_id == 1"
                    @click.prevent="onComment(record)"
                  >
                    <i class="far fa-comment-dots"></i>
                  </a>
                  <a
                    href="#"
                    class="ml-2 text-info"
                    v-tooltip="$t('homework.submitAnswerSheet')"
                    v-if="record.homework_status_id == 1"
                    @click.prevent="onViewSubmit(record)"
                  >
                    <i
                      class="fas fa-lock"
                      v-if="isLock(record.student_homework[0])"
                    ></i>
                    <i class="fas fa-file-upload" v-else></i>
                  </a>
                  <a
                    href="#"
                    class="ml-2 text-primary"
                    v-tooltip="$t('homework.privateComment')"
                    v-if="
                      record.homework_status_id == 1 &&
                        record.student_homework.length > 0
                    "
                    @click.prevent="onPrivateComment(record)"
                  >
                    <i class="fas fa-envelope-open-text"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <div class="d-flex justify-content-end p-15">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
      <a-modal
        v-if="view_homework"
        v-model="view_homework"
        :title="$t('view')"
        :footer="null"
        :zIndex="1020"
        width="500px"
        @cancel="closeModel"
      >
        <view-homework :resources="view_resources" />
      </a-modal>
      <a-modal
        v-if="submit_answer_sheet"
        v-model="submit_answer_sheet"
        :title="$t('homework.answer')"
        :footer="null"
        :zIndex="1020"
        :maskClosable="false"
        width="500px"
        @cancel="closeSubmitModal"
      >
        <submit-answer :resources="view_resources" @close="closeSubmitModal" />
      </a-modal>
      <a-modal
        v-if="view_private_comment"
        v-model="view_private_comment"
        :title="$t('homework.comment')"
        :maskClosable="false"
        :footer="null"
        :zIndex="1020"
        width="500px"
        @cancel="closeModalComment"
      >
        <private-comment :resources="view_resources" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import ViewHomework from '../../../eschool/homework/student/component/view-homework'
import SubmitAnswer from '../../../eschool/homework/student/component/submit-answer-sheet'
import PrivateComment from '../../../eschool/homework/student/component/private-comment'

export default {
  name: 'homeworkLinkFromHome',
  components: {
    ViewHomework,
    SubmitAnswer,
    PrivateComment
  },
  data() {
    return {
      loading: false,
      view_homework: false,
      view_private_comment: false,
      submit_answer_sheet: false,
      visible: false,
      homework_status_loading: false,
      rangeDate: [moment().add(-2, 'Month'), moment().add(1, 'Month')]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('home/studentHomeworkLinkFromHome', [
      'resources',
      'pagination'
    ]),
    search: {
      get() {
        return this.$store.state.home.studentHomeworkLinkFromHome.search
      },
      set(newVal) {
        this.$store.commit(
          'home/studentHomeworkLinkFromHome/SET_SEARCH',
          newVal
        )
        this.$store.commit(
          'home/studentHomeworkLinkFromHome/RESET_CURRENT_PAGE'
        )
      }
    },
    homework_status_id: {
      get() {
        return this.$store.state.home.studentHomeworkLinkFromHome
          .homework_status_id
      },
      set(newValue) {
        this.$store.commit(
          'home/studentHomeworkLinkFromHome/SET_HOMEWORK_STATUS',
          newValue
        )
      }
    },
    columns() {
      return [
        { name: this.$t('homework.date') },
        { name: this.$t('homework.class') },
        { name: this.$t('homework.subject') },
        { name: this.$t('homework.remark') },
        {
          name: this.$t('homework.submissionEnddate'),
          style: 'text-align: center'
        },
        {
          name: this.$t('homework.score'),
          style: 'text-align: center'
        },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    },
    isLock: () => record => {
      if (record != undefined) {
        return record.is_accepted
      }
      return false
    }
  },
  methods: {
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch('home/studentHomeworkLinkFromHome/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'home/studentHomeworkLinkFromHome/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'home/studentHomeworkLinkFromHome/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    onComment(record) {
      this.$router.push({
        name: 'homework-comment-public',
        params: { id: record.homework_id }
      })
    },
    onView(record) {
      this.view_homework = true
      this.view_resources = record
    },
    onViewSubmit(record) {
      if (this.isLock(record.student_homework[0])) {
        this.$toasted.info('This homework temporary is locked by teacher.')
        return
      }
      this.submit_answer_sheet = true
      this.view_resources = record
    },
    onPrivateComment(record) {
      this.view_private_comment = true
      this.view_resources = record
    },
    closeModel() {
      this.view_homework = false
      this.view_resources = []
    },
    closeSubmitModal() {
      this.submit_answer_sheet = false
      this.view_resources = []
      this.fetchData()
    },
    closeModalComment() {
      this.view_private_comment = false
      this.view_resources = []
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('home/studentHomeworkLinkFromHome/RESET_STATE')
    this.$store.commit('home/studentHomework/RESET_STATE')
    this.$store.commit('home/studentMyRequest/RESET_STATE')
    this.$store.commit('home/studentHomework/SET_HOMEWORK_STATUS', null)
    this.$store.commit(
      'home/studentHomeworkLinkFromHome/SET_HOMEWORK_STATUS_ID',
      null
    )
    next()
  }
}
</script>
